// types/index.ts
export interface TableData {
    name: string | null;
    headers: string[];
    rows: string[][];
}

// AssetSystemType enum mapping
export enum AssetSystemType {
    NONE = 0,
    REALESTATE = 1,
    SINGLEBUILDING = 2,
    STREETLIGHTJUNCTIONBOX = 3,
    STREETLIGHT = 4,
    SOLARINSTALLATION = 5,
    SOLARINVERTER = 6,
    SOLARSTRING = 7,
    ENERGYCENTRAL = 8,
    CARCHARGINGSTATION = 9,
    TENANT = 10,
    HEATPUMP = 11,
    DISTRIBUTIONBOARD = 12,
    BOILER = 13,
    VENTILATION = 14,
    BUILDINGAUTOMATION = 15,
    HEATEXCHANGER = 16
}

// Mapping from AssetSystemType to form category
export const getFormCategoryFromSystemType = (assetSystemType: number): string => {
    switch (assetSystemType) {
        case AssetSystemType.REALESTATE:
        case AssetSystemType.SINGLEBUILDING:
            return 'building';
        case AssetSystemType.SOLARINSTALLATION:
            return 'solar';
        case AssetSystemType.SOLARINVERTER:
            return 'solar_inverter';
        case AssetSystemType.SOLARSTRING:
            return 'solar_string';
        case AssetSystemType.STREETLIGHT:
            return 'street_light';
        case AssetSystemType.STREETLIGHTJUNCTIONBOX:
            return 'street_light_junction_box';
        case AssetSystemType.VENTILATION:
            return 'ventilation';
        case AssetSystemType.HEATPUMP:
            return 'heat_pump';
        case AssetSystemType.BOILER:
            return 'boiler';
        case AssetSystemType.DISTRIBUTIONBOARD:
            return 'distribution_board';
        case AssetSystemType.BUILDINGAUTOMATION:
            return 'building_automation';
        case AssetSystemType.HEATEXCHANGER:
            return 'heat_exchanger';
        default:
            return 'unknown';
    }
};